"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewCustomFieldType extends new_item_1.default {
    constructor(newCustomFieldType) {
        super();
        this.name = newCustomFieldType.name;
        this.icon = newCustomFieldType.icon;
        this.fieldType = newCustomFieldType.fieldType;
        this.colour = newCustomFieldType.colour;
        this._permission = newCustomFieldType._permission;
    }
}
exports.default = NewCustomFieldType;
//# sourceMappingURL=new-customFieldType.js.map